import { Trans, useTranslation } from "react-i18next";
import React from "react";

import PageLayout from "../components/PageLayout.jsx";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function ResourcesDenied({ title = "Login Required" }) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  // sets redirect uri for login flow
  const authRedirect = (register) => {
    localStorage.setItem("redirectUri", location.pathname);
    navigate(register ? "/auth/register" : "/auth/login");
  };

  return (
    <PageLayout title={title}>
      <section aria-labelledby="section-heading rounded-lg">
        <div className="relative rounded-lg px-6 py-16 sm:px-12 lg:px-16">
          <div
            aria-hidden="true"
            className="bg-opacity-50 absolute inset-0 rounded-lg bg-gray-900 dark:bg-gray-800"
          ></div>
          <div className="dark relative mx-auto flex max-w-full flex-col items-center gap-3">
            <h1 className="mb-2">Register for Free Access to PROOF Materials</h1>
            <div className="self-start flex flex-col gap-3 text-base md:text-lg lg:text-xl leading-6 font-light dark:text-white">
              <p>
                By registering, you'll receive complimentary access to all PROOF materials for use in your clinical
                practice. We ask that you:
              </p>
              <ul className="list-inside list-disc">
                <li>Keep materials accessible only to registered users</li>
                <li>Direct interested colleagues to register independently rather than sharing materials</li>
              </ul>
              <p className="">What We Ask in Return</p>
              <p>
                In exchange for free access, registered users agree to occasional contact from the PROOF team regarding
                research opportunities. Your contact information will never be shared or sold to third parties.
              </p>
              <p>If you have any questions, please contact the <Link className="underline cursor-pointer text-proof-blue" to="/contact">PROOF team</Link></p>
            </div>
            <div className="flex items-center justify-between gap-8">
              <button onClick={() => authRedirect(false)} className="button button-blue mt-4">
                Account Login
              </button>
              <button onClick={() => authRedirect(true)} className="button button-purple mt-4">
                Register for Access
              </button>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
